<ng-container *ngIf="title || isSlider" [ngSwitch]="css">
  <ion-item lines="none ion-no-padding">
    <div
      class="label"
      *ngSwitchCase="undefined"
      [ngStyle]="css"
      [innerHTML]="safeTitle"
    ></div>
    <div
      class="label"
      *ngSwitchDefault
      [ngStyle]="css"
      [innerHTML]="safeTitle"
    ></div>
    <!-- Reset button for slider -->
    <div slot="end" class="end-slot" *ngIf="isSlider">
      <ion-button
        [disabled]="value === ''"
        fill="default"
        (click)="resetHandle()"
        size="small"
        class="button-clear"
      >
        <svg
          width="26"
          height="24"
          viewBox="0 0 26 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.37645 19.6964C9.37645 19.6964 8.47131 19.7785 12.7528 20.1154C14.2862 20.2361 15.8209 19.8994 17.1629 19.1478C18.5049 18.3963 19.5938 17.2637 20.2921 15.8932C20.9904 14.5227 21.2666 12.976 21.0858 11.4486C20.9051 9.92111 20.2754 8.48158 19.2765 7.312C18.2776 6.14241 16.9542 5.29531 15.4739 4.87781C13.9935 4.4603 12.4226 4.49115 10.9598 4.96645C9.49698 5.44175 8.20795 6.34016 7.25572 7.54805C6.30349 8.75595 5.73082 10.2191 5.61015 11.7525"
            stroke="var(--bepatient-slider-reset-btn)"
            stroke-width="3"
            stroke-miterlimit="10"
            stroke-linecap="round"
          />
          <path
            d="M10.6833 10.1963L5.54283 14.1407L1.59837 9.00023"
            stroke="var(--bepatient-slider-reset-btn)"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </ion-button>
    </div>
  </ion-item>
</ng-container>

<div id="divTitle">
  <div id="afterTitle" #afterTitle></div>
  <div [hidden]="isRequired" #optionalRes>
    ( {{ 'OPTIONAL' | translate | uppercase }} )
  </div>
</div>
<div id="error" [hidden]="!errorMsg">
  <div>
    {{ errorMsg | translate }}
  </div>
</div>
<div id="infos" [hidden]="!infos">
  {{ infos }}
</div>
